import {Link as PrimerLink} from '@primer/react'
import type {IssueCommentInfo} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'
import {Link} from '@github-ui/react-router'
import {routeToIssueComment, useCurrentPathParams} from '../../../overview/data/use-comments-routing'

export function IssueCommentAction({info}: {info: IssueCommentInfo}) {
  const pathParams = useCurrentPathParams()
  const commentId = info.commentId

  if (!commentId) {
    return <>commented</>
  }
  return (
    <PrimerLink
      as={Link}
      to={routeToIssueComment(pathParams, commentId.toString())}
      inline
      className="fgColor-default text-semibold"
    >
      commented
    </PrimerLink>
  )
}
